/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailQueryResponse,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailPathParams,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail401,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail404,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail500,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail } from "../../clients/classPlanningGradeAndFrequenceConfigurationController/getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail.ts";

export const getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailQueryKey =
  (
    courseRegistrationId: GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailPathParams["courseRegistrationId"],
  ) =>
    [
      {
        url: "/api/v1/classroomdiscipline/grade-and-frequence/course-registrations/:courseRegistrationId/grade-detail",
        params: { courseRegistrationId: courseRegistrationId },
      },
    ] as const;

export type GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailQueryKey =
  ReturnType<
    typeof getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailQueryKey
  >;

export function getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailQueryOptions(
  courseRegistrationId: GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailPathParams["courseRegistrationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailQueryKey(
      courseRegistrationId,
    );
  return queryOptions<
    GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail401
      | GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail404
      | GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail500
    >,
    GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailQueryResponse,
    typeof queryKey
  >({
    enabled: !!courseRegistrationId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail(
        courseRegistrationId,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna a média e frequência finais do aluno e todos os Módulos com suas Disciplinas (média + frequência por Disciplina) e cada Aula (nota + peso da avaliação). **(Requer Authorization para autenticação)**
 * @summary Detalhe de notas e frequências do aluno (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/grade-and-frequence/course-registrations/:courseRegistrationId/grade-detail}
 */
export function useGetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail<
  TData =
    GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailQueryResponse,
  TQueryData =
    GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailQueryKey,
>(
  courseRegistrationId: GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailPathParams["courseRegistrationId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail401
          | GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail404
          | GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailQueryKey(
      courseRegistrationId,
    );

  const query = useQuery(
    {
      ...getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailQueryOptions(
        courseRegistrationId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail401
      | GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail404
      | GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
